// extracted by mini-css-extract-plugin
module.exports = {"fontDefaultColor":"#fff","fontDefaultColorDarker":"#ccc","themeBackground":"#1b1b1b","themeWaves":"#1c1c1c","themeWavesDark":"#000102"};